import React from 'react';
import { Trans } from '@lingui/macro';

/** v3 */
const ICMMap: Record<string, JSX.Element> = {
  '10XX': <Trans>Technology</Trans>,
  '15XX': <Trans>Telecommunications</Trans>,
  '20XX': <Trans>Health Care</Trans>,
  '30XX': <Trans>Financials </Trans>,
  '35XX': <Trans>Real Estate</Trans>,
  '40XX': <Trans>Consumer Discretionary</Trans>,
  '45XX': <Trans>Consumer Staples</Trans>,
  '50XX': <Trans>Industrials</Trans>,
  '55XX': <Trans>Basic Materials</Trans>,
  '60XX': <Trans>Energy</Trans>,
  '65XX': <Trans>Utilities</Trans>,
};

export default function mapICB(
  input: string | undefined,
): JSX.Element | undefined {
  if (!input) return undefined;

  const key = Object.keys(ICMMap).find(key => {
    return key.startsWith(input.charAt(0) + input.charAt(1));
  });

  return key ? ICMMap[key] : undefined;
}
